import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { BusinessRegistrationPageComponent } from './business-registration-page/business-registration-page.component'
import { BusinessRegistrationAdsComponent } from './business-registration-ads/business-registration-ads.component'

const routes: Routes = [
  {
    path: '',
    component: BusinessRegistrationPageComponent,
  },
  {
    path: '2',
    component: BusinessRegistrationAdsComponent,
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BusinessRegistrationRoutingModule {}
